import React from 'react';
import ClientForm from 'components/ClientForm';

const AddEditClient: React.FC = () => <ClientForm />;

export default AddEditClient;
